import { css } from '@emotion/react';
import { p2r } from '../../styles/fonts';
import { breakpoints } from '../../styles';

const SHADOW_SIZE = p2r(32);
const SHADOW_SIZE_MOBILE = p2r(32 / 2);
const gap = 10;
const TABLET_SHADOW_SIZE = p2r(20);

const shadowTemplate = (shadowSise, shadowX, shadowY, color) => `
  -moz-box-shadow: ${shadowX}${shadowSise} ${shadowY}${shadowSise} 0 ${color};
  -webkit-box-shadow: ${shadowX}${shadowSise} ${shadowY}${shadowSise} 0 ${color};
  -khtml-box-shadow: ${shadowX}${shadowSise} ${shadowY}${shadowSise} 0 ${color};
  box-shadow: ${shadowX}${shadowSise} ${shadowY}${shadowSise} 0 ${color};
`;

const styles = ({ shadowColor }) => css`
  .image {
    width: 100%;
    max-width: 492px;
    height: 100%;
    min-height: ${p2r(256)};
    object-fit: cover;

    &--mobile {
      display: none;
    }
  }

  .top-left-conner-shadow {
    margin-top: ${SHADOW_SIZE};
    ${shadowTemplate(SHADOW_SIZE, '-', '-', shadowColor)}
  }

  .bottom-right-conner-shadow {
    margin-bottom: ${SHADOW_SIZE};
    ${shadowTemplate(SHADOW_SIZE, '+', '+', shadowColor)}
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .image {
      max-width: 90%;
      min-height: 90%;
    }

    .top-left-conner-shadow {
      margin: ${TABLET_SHADOW_SIZE} 0 0 ${TABLET_SHADOW_SIZE};
      ${shadowTemplate(TABLET_SHADOW_SIZE, '-', '-', shadowColor)}
    }

    .bottom-right-conner-shadow {
      float: right;
      margin-right: ${20 + gap}px;
      ${shadowTemplate(TABLET_SHADOW_SIZE, '+', '+', shadowColor)}
    }
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    .top-left-conner-shadow {
      margin: ${p2r(32)} ${SHADOW_SIZE};
    }

    .bottom-right-conner-shadow {
      margin: 0 ${SHADOW_SIZE};
    }
  }

  @media (max-width: ${breakpoints.mobile}px) {
    .image {
      &--desktop {
        display: none;
      }

      &--mobile {
        display: block;
        width: 100%;
        max-width: 343px;
        height: 100%;
        min-height: ${p2r(256)};
      }
    }

    .top-left-conner-shadow--mobile {
      margin: 0 0 ${p2r(32)} ${SHADOW_SIZE_MOBILE};
      ${shadowTemplate(SHADOW_SIZE_MOBILE, '-', '-', shadowColor)}
    }

    .bottom-right-conner-shadow--mobile {
      float: right;
      margin-right: ${SHADOW_SIZE_MOBILE};
      ${shadowTemplate(SHADOW_SIZE_MOBILE, '+', '+', shadowColor)}
    }
  }
`;

export default styles;
